import { Button, FormLabel, Modal, ModalDialog, Textarea, Divider } from '@mui/joy';
import React from 'react';
import { sanitizeHtml } from '../Helpers';

interface DynamicViewModalProps {
    isOpen: boolean;
    onClose: () => void;
    value: any;
}


const DynamicViewModal = ({ isOpen, onClose, value }: DynamicViewModalProps) => {
    const hasHtml = value.value && /<[a-z][\s\S]*>/i.test(value.value);

    return (
        <Modal open={isOpen} onClose={onClose}>
            <ModalDialog sx={{minWidth: "70%"}}>
                <h3>Details</h3>
                <Divider />
                <FormLabel sx={{ marginTop: "1rem", paddingBottom: "0.5rem" }}>{value.label}</FormLabel>

                {hasHtml ? (
                    <div
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(value.value) }}
                        style={{
                            padding: '8px 12px',
                            border: '1px solid var(--color-box-border, #ccc)',
                            borderRadius: '4px',
                            minHeight: '120px',
                            backgroundColor: 'var(--color-input-bg, #fff)',
                            color: 'var(--color-text, #000)',
                            overflowY: 'auto',
                            maxHeight: '60vh',
                        }}
                    />
                ) : (
                    <Textarea
                        name={value.label}
                        value={value.value}
                        minRows={5}
                    />
                )}
            </ModalDialog>
        </Modal>
    );
}

export default DynamicViewModal;
